// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-add-container .email-thread{display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:100%}\n", ""]);
// Exports
module.exports = exports;
